module.exports = __webpack_public_path__ + "img/new-1.c2004d8b.png";